import React from 'react'
import { useEffect } from "react";
import { Typography } from '@material-tailwind/react';
import Banner from '../Components/banner/Banner';
import BannerData from '../models/BannersData';
import ContactUsForm from '../Components/form/ContactUsForm'
import TitleComponent from '../Components/common/TitleComponent';
import BreadcrumbsComponent from '../Components/common/BreadcrumbsComponent';

function ContactUsPage() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const BreadCrumbsPath = [
        {
            id: 1,
            pathName: "Contact us",
            pathLink: "/Contact-us",
        },
    ];

    return (
        <>

            {BannerData.filter(item => item.title === 'Contact Us').map((item) => (
                <Banner key={item.id} bannerDetails={item} />
            ))}

            <BreadcrumbsComponent fullWidth BreadCrumbsPath={BreadCrumbsPath} />

            <TitleComponent Title={"Contact us"} Subtitle={"Fill the below for to get in touch with us."} />

            <ContactUsForm />
        </>
    )
}

export default ContactUsPage